import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.find";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import draggable from "vuedraggable";
import { mapGetters, mapActions } from "vuex";
import schoolDate from "./childModules/SchoolDate";
import note from "./childModules/Note";
import schedule from "./childModules/Schedule";
import affair from "./childModules/affair";
import { getCardList } from "@/api/managementCenter/specialManage";
export default {
  name: "card",
  components: {
    draggable: draggable,
    schoolDate: schoolDate,
    note: note,
    schedule: schedule,
    affair: affair
  },
  props: ["childModules"],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      moduleItems: [],
      span: 1,
      col: 2,
      noticeList: [],
      policyFileList: []
    };
  },
  created: function created() {
    var subject = this.moduleList.find(function (item) {
      return item.cardType === "CARD";
    });

    if (subject) {
      this.moduleItems = JSON.parse(JSON.stringify(subject.cardModules));
      this.col = subject.cardCol;
    }
  },
  computed: _objectSpread({}, mapGetters(["moduleList"])),
  mounted: function mounted() {
    this.getCardData("0");
    this.getCardData("1");
  },
  methods: {
    getCardData: function getCardData(type) {
      var _this = this;

      var params = {
        type: type || ""
      };
      getCardList(params).then(function (res) {
        if (type == "0") {
          _this.noticeList = res.data.data.records;
        }

        if (type == "1") {
          _this.policyFileList = res.data.data.records;
        }
      });
    },
    changeLayout: function changeLayout() {
      // if(this.col * this.span < this.moduleItems.length){
      //   this.moduleItems.length = this.col * this.span
      // }
      this.$emit("caseChanged", true);
    },
    handleWidth: function handleWidth(col) {
      switch (col) {
        case 1:
          return "100%";

        case 2:
          return "50%";

        case 3:
          return "33.3%";

        case 4:
          return "25%";

        case 5:
          return "20%";

        case 6:
          return "16.6%";

        default:
          return "50%";
      }
    },
    addModuleItem: function addModuleItem(e) {
      // // 判断是否超出个数限制
      // const limit = this.span * this.col;
      // if(this.moduleItems.length >= limit){
      //   this.$message.warning('超出设置的行数,若要继续添加请修改行列数')
      //   return
      // }
      var targetIndex = e.newIndex;
      var childModulesIndex = e.oldIndex;
      var childModule = this.childModules[childModulesIndex]; // 判断添加的模块是否存在
      // const exist = this.moduleItems.some((item) => {
      //   return item.code === childModule.code;
      // })

      var exist;

      if (this.moduleItems) {
        exist = this.moduleItems.some(function (item) {
          return item.code === childModule.code;
        });
      } else {
        this.moduleItems = [];
        exist = false;
      }

      if (exist) {
        this.$message.warning("不能重复添加已添加的模块");
        return;
      }

      this.moduleItems.splice(targetIndex, 0, childModule);
      this.$emit("caseChanged", true);
    },
    sortModuleItem: function sortModuleItem(e) {
      var newIndex = e.newIndex;
      var oldIndex = e.oldIndex;
      var moduleItem = this.moduleItems[oldIndex];
      this.moduleItems.splice(oldIndex, 1);
      this.moduleItems.splice(newIndex, 0, moduleItem);
      this.$emit("caseChanged", true);
    },
    removeModules: function removeModules(item, index) {
      this.moduleItems.splice(index, 1);
      this.$emit("caseChanged", true);
    },
    isEmpty: function isEmpty() {
      return this.moduleItems.length ? false : true;
    }
  },
  watch: {
    moduleItems: function moduleItems(val) {
      this.$emit("selectedChange", {
        data: val,
        module: "card",
        col: this.col
      });
    },
    col: function col(val) {
      this.$emit("selectedChange", {
        data: this.moduleItems,
        module: "card",
        col: this.col
      });
    }
  },
  filters: {}
};